import { Check, CircleDashed, Inbox } from "lucide-react";

export function ReadinessItem({ title, detail, ready = false }: { title: string; detail: string; ready?: boolean }) {
  return <li className={ready ? "is-ready" : ""}>{ready ? <Check aria-hidden="true" size={17} /> : <CircleDashed aria-hidden="true" size={17} />}<div><strong>{title}</strong><span>{detail}</span></div></li>;
}

export function ZeroState({ title, description }: { title: string; description: string }) {
  return <div className="workspace-zero"><Inbox aria-hidden="true" size={20} /><div><strong>{title}</strong><p>{description}</p></div></div>;
}

export function LocalSegmentedControl({ label, options, value, onChange }: { label: string; options: string[]; value: string; onChange: (value: string) => void }) {
  return <div className="local-segments" role="group" aria-label={label}>{options.map((option) => <button type="button" aria-pressed={value === option} onClick={() => onChange(option)} key={option}>{option}</button>)}</div>;
}
